module.exports = __webpack_public_path__ + "img/hm.216d487e.png";